import { render, staticRenderFns } from "./html-rich-editor.vue?vue&type=template&id=d5293764&scoped=true"
import script from "./html-rich-editor.vue?vue&type=script&lang=ts"
export * from "./html-rich-editor.vue?vue&type=script&lang=ts"
import style0 from "./html-rich-editor.vue?vue&type=style&index=0&id=d5293764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5293764",
  null
  
)

export default component.exports